<template>
  <v-container class="ma-0 pa-0" v-if="date && calendarId">

    <v-row no-gutters align="center" justify="space-around" class="pa-0 ma-0 pb-5">
      <v-col no-gutters class="pa-0 ma-0 pb-2 caption">

        <v-progress-circular indeterminate color="primary" v-if="loading" />

        <div v-if="showMessage">Nenhum horário disponível nessa data</div>

        <div v-else >
          <div class="subtitle-2">Horários disponíveis no dia {{ date | date }}:</div>

          <div v-for="time in times" :key="time.id" class="d-flex d-inline-flex">
            <v-chip class="time ma-2" label outlined color="primary" @click="click(time)"
              :input-value="time.time == ((timeSelected) ? timeSelected.time : null)">
              {{time.time | timeToHM}}
            </v-chip>
          </div>
        </div>

      </v-col>
    </v-row>

  </v-container>
</template>


<script>
import bus from '@/plugins/eventBus';

export default {
  props: {
    value: {
      type: Object,
    },
    date: {
      type: String,
      required: true,
    },
    calendarId: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      default: 'normal',
    },
  },
  data: () => ({
    times: [],
    timeSelected: null,
    loading: false,
    showMessage: false,
  }),
  mounted() {
    if (this.date && this.calendarId) {
      this.getTimes();
    }

    bus.$on('schedule-refresh', this.getTimes);
  },
  methods: {
    getTimes() {
      if (this.date && this.calendarId && this.type) {
        this.times = [];
        this.showMessagem = false;
        this.loading = true;
        this.$store
          .dispatch('calendars/getTimes', { id: this.calendarId, date: this.date, type: this.type })
          .then((times) => {
            this.times = times;
            this.showMessage = !times || times.length === 0;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    click(time) {
      this.timeSelected = time;
      this.$emit('input', time);
    },
  },
  watch: {
    date() {
      this.getTimes();
      this.timeSelected = null;
    },
    calendarId() {
      this.getTimes();
      this.timeSelected = null;
    },
    type() {
      this.getTimes();
      this.timeSelected = null;
    },
  },
};
</script>

<style scoped>
  .time.v-chip.v-chip--active {
    background-color: #1976d2 !important;
    color: white !important;
  }
</style>
